import React from 'react';
import { Tile, AvatarCircle, NameChip, CaptionBox, AskingPill, ListeningHint } from './CallTiles.styles';
import { GLOW } from './tileGlow';

// Served from ui/public/ — same convention as PageFrame.jsx and the PDF assets.
const MULTIPLY_ICON_URL = '/images/multiply-icon.png';

const MicSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M12 18v3" />
  </svg>
);

/**
 * A camera-off attendee tile, Teams-style: dark tile, centered avatar circle,
 * name chip. Personas keep their initials avatar + avatarColor; the synthetic
 * Murphy tile (modes with no participants) uses the Multiply mark.
 *
 * The WHOLE tile is the interaction surface: in L2 click-to-hear mode the
 * click that used to land on a small sidebar card lands here (a far bigger
 * target — missing it costs the rep points).
 */
const ParticipantTile = ({
  name,
  avatar,
  avatarColor,
  isMurphy = false,
  glow = GLOW.NONE,
  caption = null,
  listeningHint = false,
  onClick,
}) => {
  const clickable = typeof onClick === 'function';
  return (
    <Tile
      $glow={glow}
      $clickable={clickable}
      onClick={onClick}
      data-testid={`participant-tile-${name}`}
      role={clickable ? 'button' : undefined}
    >
      {glow === GLOW.BRIGHT && (
        <AskingPill data-testid="asking-pill">
          <MicSvg />
          Asking…
        </AskingPill>
      )}

      <AvatarCircle $bg={isMurphy ? '#202126' : avatarColor} $size={isMurphy ? 96 : 88}>
        {isMurphy
          ? <img src={MULTIPLY_ICON_URL} alt="" />
          : (avatar || (name || '?').charAt(0))}
      </AvatarCircle>

      {listeningHint && glow === GLOW.NONE && (
        <ListeningHint>Listening</ListeningHint>
      )}

      <NameChip><span>{name}</span></NameChip>

      {caption && (
        <CaptionBox $dimmed={glow === GLOW.SOFT} data-testid="tile-caption">
          {caption}
        </CaptionBox>
      )}
    </Tile>
  );
};

export default ParticipantTile;
